var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"owl-dot col4 atom-content-thumb-slider-brochure",on:{"click":_vm.handleClick}},[_c('span',{staticClass:"line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }